// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_MAIN_DESKTOP: 88,
  H_DASHBOARD_DESKTOP: 92,
  H_DASHBOARD_DESKTOP_OFFSET: 92 - 32,
}

export const NAV = {
  W_BASE: 260,
  W_DASHBOARD: 280,
  W_DASHBOARD_MINI: 88,
  //
  H_DASHBOARD_ITEM: 48,
  H_DASHBOARD_ITEM_SUB: 36,
  //
  H_DASHBOARD_ITEM_HORIZONTAL: 32,
}

export const ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
}

// SETTINGS
// Please remove `localStorage` when you set settings.
// ----------------------------------------------------------------------

export const defaultSettings = {
  themeMode: "light",
  themeColorPresets: "satorange",
  themeStretch: true,
}

export const BACKEND_URL: string = import.meta.env.VITE_BACKEND_URL || "http://localhost:8000/api"

export const LOGIN_URL: string = import.meta.env.VITE_LOGIN_URL

export const APPLICATION_REF: string = import.meta.env.VITE_APPLICATION_REF

export const REQUIRED_GROUPS: string[] = ["staff", "pl_external", "pl_external_o", "pl_lensen"]

export const APP_NAME: string = "Prijslijst"
export const APP_NAME_ORIGINALS: string = "SatellietOriginals"
export const APP_NAME_SHORT: string = "PL"
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION || "0.0.1"

export const ENVIRONMENT: string = import.meta.env.VITE_ENVIRONMENT || "development"

export const ORIGINALS_DOMAIN: string = "pricelist.satellietoriginals.net"

export const MAIN_DOMAIN: string = "prijslijst.satelliet.net"

export const CORS_ORIGIN = (import.meta.env.VITE_ROOT_URL || ("https://localhost:3020" as string))
  .replace("https://", "")
  .replace("http://", "")
